// import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
// import {
//   Box, Paper, Typography, TextField, Button, Chip, IconButton, Tooltip,
//   Dialog, DialogTitle, DialogContent, DialogActions, Snackbar, Alert, Grid,
// } from '@mui/material';
// import {
//   Add as AddIcon,
//   Search as SearchIcon,
//   Refresh as RefreshIcon,
//   Edit as EditIcon,
//   Delete as DeleteIcon,
//   ContentCopy as ContentCopyIcon,
//   VpnKey as VpnKeyIcon,
// } from '@mui/icons-material';
// import debounce from 'lodash/debounce';
// import { adminService } from '../../services/admin';
// import DataTable from '../common/DataTable'; // same DataTable used by BusinessList
// import LoadingSpinner from '../common/LoadingSpinner';

// const ApplicationList = () => {
//   const navigate = useNavigate();
//   const [applications, setApplications] = useState([]);
//   const [tableLoading, setTableLoading] = useState(true);
//   const [initialLoading, setInitialLoading] = useState(true);
//   const [searchInput, setSearchInput] = useState('');
//   const [search, setSearch] = useState('');
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [totalRows, setTotalRows] = useState(0);
//   const [deleteDialog, setDeleteDialog] = useState(null);
//   const [secretDialog, setSecretDialog] = useState(null);
//   const [actionLoading, setActionLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const debouncedSearch = useCallback(
//     debounce((value) => {
//       setSearch(value);
//       setPage(0);
//     }, 500),
//     []
//   );
//   useEffect(() => () => debouncedSearch.cancel(), [debouncedSearch]);

//   useEffect(() => {
//     fetchApplications(true);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   useEffect(() => {
//     if (!initialLoading) fetchApplications(false);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [page, rowsPerPage, search]);

//   const fetchApplications = async (isInitial = false) => {
//     try {
//       isInitial ? setInitialLoading(true) : setTableLoading(true);
//       const res = await adminService.getBusinessApps({
//         page: page + 1,
//         limit: rowsPerPage,
//         search,
//       });
//       // ⚠️ Adjust these two lines if your API returns a different shape
//       setApplications(res.data || res.apps || []);
//       setTotalRows(res.total || 0);
//     } catch (err) {
//       console.error('Error fetching applications:', err);
//       setSnackbar({ open: true, message: 'Failed to fetch applications', severity: 'error' });
//     } finally {
//       if (isInitial) setInitialLoading(false);
//       setTableLoading(false);
//     }
//   };

//   const handleRefresh = () => {
//     fetchApplications(false);
//     setSnackbar({ open: true, message: 'Applications refreshed', severity: 'success' });
//   };

//  const handleToggleStatus = async (app) => {
//   try {
//     setActionLoading(true);
//     await adminService.toggleBusinessAppStatus(app._id, !app.enabled);
//     setSnackbar({ open: true, message: `Application ${app.enabled ? 'disabled' : 'enabled'}`, severity: 'success' });
//     await fetchApplications(false);
//   } catch (err) {
//     setSnackbar({ open: true, message: 'Failed to update status', severity: 'error' });
//   } finally {
//     setActionLoading(false);
//   }
// };

// const handleRotateSecret = async (app) => {
//   try {
//     setActionLoading(true);
//     const res = await adminService.rotateBusinessAppSecret(app._id);
//     setSecretDialog({ app, secret: res.secretKey || res.secret });
//     setSnackbar({ open: true, message: 'Secret rotated', severity: 'success' });
//   } catch (err) {
//     setSnackbar({ open: true, message: 'Failed to rotate secret', severity: 'error' });
//   } finally {
//     setActionLoading(false);
//   }
// };

// const handleDelete = async () => {
//   if (!deleteDialog) return;
//   try {
//     setActionLoading(true);
//     await adminService.deleteApplication(deleteDialog._id);
//     setSnackbar({ open: true, message: 'Application deleted', severity: 'success' });
//     setDeleteDialog(null);
//     await fetchApplications(false);
//   } catch (err) {
//     setSnackbar({ open: true, message: 'Failed to delete application', severity: 'error' });
//   } finally {
//     setActionLoading(false);
//   }
// };

//   const handleCopy = (value) => {
//     if (!value) return;
//     navigator.clipboard.writeText(value).catch(() => {});
//     setSnackbar({ open: true, message: 'Copied to clipboard', severity: 'success' });
//   };

// const columns = [
//   { field: 'appName', headerName: 'App Name', sortable: true },
//   { field: 'appType', headerName: 'Type', sortable: true },
//   {
//     field: 'businessId',
//     headerName: 'Business ID',
//     width: 200,
//     render: (value) => {
//       const id = value || '';
//       const short = id.length > 16 ? `${id.slice(0, 14)}…` : id;
//       return (
//         <Tooltip title={`Click to copy: ${id}`}>
//           <Typography
//             sx={{ fontFamily: 'monospace', fontSize: '0.75rem', cursor: 'pointer', '&:hover': { color: '#3182ce' } }}
//             onClick={() => handleCopy(id)}
//           >
//             {short}
//           </Typography>
//         </Tooltip>
//       );
//     },
//   },
//   {
//     field: 'allowedDomains',
//     headerName: 'Domains',
//     render: (_, app) => {
//       const count = Array.isArray(app.allowedDomains) ? app.allowedDomains.length : 0;
//       return <Chip label={count} size="small" sx={{ bgcolor: '#f1f5f9', fontWeight: 600 }} />;
//     },
//   },
//   {
//     field: 'enabled',
//     headerName: 'Status',
//     sortable: true,
//     render: (value, app) => (
//       <Chip
//         label={app.blockDetails?.isBlocked ? 'BLOCKED' : value ? 'ENABLED' : 'DISABLED'}
//         size="small"
//         onClick={() => !app.blockDetails?.isBlocked && handleToggleStatus(app)}
//         sx={{
//           fontWeight: 600,
//           cursor: app.blockDetails?.isBlocked ? 'default' : 'pointer',
//           bgcolor: app.blockDetails?.isBlocked ? '#fee2e2' : value ? '#dcfce7' : '#f1f5f9',
//           color: app.blockDetails?.isBlocked ? '#991b1b' : value ? '#166534' : '#64748b',
//         }}
//       />
//     ),
//   },
//   {
//     field: 'actions',
//     headerName: 'Actions',
//     align: 'center',
//     render: (_, app) => (
//       <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
//         <Tooltip title="Rotate Secret">
//           <IconButton size="small" onClick={() => handleRotateSecret(app)} sx={{ color: '#0369a1' }}>
//             <VpnKeyIcon fontSize="small" />
//           </IconButton>
//         </Tooltip>
//         <Tooltip title="Edit Application">
//           <IconButton size="small" onClick={() => navigate(`/admin/applications/${app._id}/edit`)} sx={{ color: '#f59e0b' }}>
//             <EditIcon fontSize="small" />
//           </IconButton>
//         </Tooltip>
//         <Tooltip title="Delete Application">
//           <IconButton size="small" onClick={() => setDeleteDialog(app)} sx={{ color: '#ef4444' }}>
//             <DeleteIcon fontSize="small" />
//           </IconButton>
//         </Tooltip>
//       </Box>
//     ),
//   },
// ];

//   if (initialLoading) return <LoadingSpinner />;

//   return (
//     <Box sx={{ minHeight: '100%', background: '#2563EB', p: 3 }}>
//       <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//         <Box>
//           <Typography variant="h5" sx={{ fontWeight: 700, background: '#2563EB', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
//             Applications
//           </Typography>
//           <Typography variant="body2" sx={{ color: '#64748b' }}>
//             Manage business applications, domains, and keys
//           </Typography>
//         </Box>
//         <Tooltip title="Refresh Table">
//           <IconButton onClick={handleRefresh} disabled={tableLoading} sx={{ backgroundColor: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
//             <RefreshIcon />
//           </IconButton>
//         </Tooltip>
//       </Box>

//       <Paper elevation={0} sx={{ borderRadius: 3, border: '1px solid rgba(49,130,206,0.2)', p: 3 }}>
//         <Grid container spacing={2} sx={{ mb: 2 }}>
//           <Grid item xs={12} md={6}>
//             <TextField
//               fullWidth
//               placeholder="Search applications..."
//               value={searchInput}
//               onChange={(e) => { setSearchInput(e.target.value); debouncedSearch(e.target.value); }}
//               InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1 }} /> }}
//             />
//           </Grid>
//           <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
//             <Button
//               variant="contained"
//               startIcon={<AddIcon />}
//               onClick={() => navigate('/admin/applications/create')}
//               sx={{ background: '#2563EB', fontWeight: 600, textTransform: 'none' }}
//             >
//               Add Application
//             </Button>
//           </Grid>
//         </Grid>

//         <Box sx={{ position: 'relative' }}>
//           {tableLoading && (
//             <Box sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'rgba(255,255,255,0.7)', zIndex: 1 }}>
//               <LoadingSpinner size={40} />
//             </Box>
//           )}
//           <DataTable
//             columns={columns}
//             data={applications}
//             page={page}
//             rowsPerPage={rowsPerPage}
//             totalRows={totalRows}
//             onPageChange={setPage}
//             onRowsPerPageChange={setRowsPerPage}
//           />
//         </Box>
//       </Paper>

//       <Dialog open={!!deleteDialog} onClose={() => !actionLoading && setDeleteDialog(null)}>
//         <DialogTitle>Delete Application</DialogTitle>
//         <DialogContent>
//           Are you sure you want to delete <strong>{deleteDialog?.name}</strong>? This action cannot be undone.
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialog(null)} disabled={actionLoading}>Cancel</Button>
//           <Button color="error" onClick={handleDelete} disabled={actionLoading}>
//             {actionLoading ? 'Deleting...' : 'Delete'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={!!secretDialog} onClose={() => setSecretDialog(null)} maxWidth="sm" fullWidth>
//         <DialogTitle>New Secret for {secretDialog?.app?.name}</DialogTitle>
//         <DialogContent dividers>
//           <Box sx={{ bgcolor: '#0f172a', color: '#e2e8f0', p: 2, borderRadius: 1, fontFamily: 'monospace', fontSize: '0.8rem' }}>
//             {secretDialog?.secret}
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           <Button startIcon={<ContentCopyIcon />} onClick={() => handleCopy(secretDialog?.secret)}>Copy</Button>
//           <Button onClick={() => setSecretDialog(null)}>Close</Button>
//         </DialogActions>
//       </Dialog>

//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={3000}
//         onClose={() => setSnackbar({ ...snackbar, open: false })}
//         anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//       >
//         <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default ApplicationList;

import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme, alpha } from '@mui/material/styles';
import {
  Box, Paper, Typography, TextField, Button, Chip, IconButton, Tooltip,
  Dialog, DialogTitle, DialogContent, DialogActions, Snackbar, Alert, Grid,
  Select, MenuItem, FormControl, InputLabel,
} from '@mui/material';
import {
  Add as AddIcon,
  Search as SearchIcon,
  Refresh as RefreshIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  ContentCopy as ContentCopyIcon,
} from '@mui/icons-material';
import debounce from 'lodash/debounce';
import { adminService } from '../../services/admin';
import DataTable from '../common/DataTable'; // same DataTable used by BusinessList
import LoadingSpinner from '../common/LoadingSpinner';

// Empty filter shape — keep this in one place so resets stay in sync everywhere.
const EMPTY_FILTERS = {
  appName: '',
  appType: '',
  businessName: '',
};

const ApplicationList = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const navigate = useNavigate();
  const [applications, setApplications] = useState([]);
  const [businesses, setBusinesses] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);
  const [initialLoading, setInitialLoading] = useState(true);

  // What the user is actively typing (controlled inputs — updates instantly, no lag on screen)
  const [filterInputs, setFilterInputs] = useState(EMPTY_FILTERS);
  // What actually drives the fetch (updates only after debounce settles)
  const [filters, setFilters] = useState(EMPTY_FILTERS);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [deleteDialog, setDeleteDialog] = useState(null);
  const [secretDialog, setSecretDialog] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  // Ref so the debounced callback always sees the latest filterInputs
  // without needing to be recreated (and without re-triggering the effect below).
  const filterInputsRef = useRef(filterInputs);
  filterInputsRef.current = filterInputs;

  // Single debounce for all four fields — whichever one the user is typing in,
  // we commit the *whole* current filter set 500ms after they stop typing.
  const debouncedCommitFilters = useCallback(
    debounce(() => {
      setPage(0);
      setFilters({ ...filterInputsRef.current });
    }, 500),
    []
  );
  useEffect(() => () => debouncedCommitFilters.cancel(), [debouncedCommitFilters]);

  const handleFilterChange = (field) => (e) => {
    const value = e.target.value;
    setFilterInputs((prev) => ({ ...prev, [field]: value }));
    debouncedCommitFilters();
  };

  // Dropdown filters (Type, Business Name) are a single discrete pick, not
  // something a user "types" — commit immediately instead of waiting out
  // the same 500ms debounce meant for the free-text App Name field.
  const handleDropdownFilterChange = (field) => (e) => {
    const value = e.target.value;
    debouncedCommitFilters.cancel();
    setFilterInputs((prev) => {
      const next = { ...prev, [field]: value };
      setPage(0);
      setFilters(next);
      return next;
    });
  };

  // Populate the Business Name dropdown with every business, same call the
  // Create Application wizard already uses for its business picker.
  useEffect(() => {
    adminService
      .getAllBusinesses(0, 200)
      .then((data) => {
        let list = [];
        if (Array.isArray(data)) list = data;
        else if (data.businesses && Array.isArray(data.businesses)) list = data.businesses;
        else if (data.data && Array.isArray(data.data)) list = data.data;
        setBusinesses(list);
      })
      .catch(() => {});
  }, []);

  const handleClearFilters = () => {
    debouncedCommitFilters.cancel();
    setFilterInputs(EMPTY_FILTERS);
    setPage(0);
    setFilters(EMPTY_FILTERS);
  };

  // Initial full-page load (spinner covers the whole view)
  useEffect(() => {
    fetchApplications(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Every subsequent load (search, pagination) — table-only overlay, page chrome stays put
  useEffect(() => {
    if (!initialLoading) fetchApplications(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, filters]);

  const fetchApplications = async (isInitial = false) => {
    try {
      isInitial ? setInitialLoading(true) : setTableLoading(true);
      const res = await adminService.getBusinessApps({
        page: page + 1,
        limit: rowsPerPage,
        // Sent as separate prefix-search params — adjust names to match your API.
        // e.g. appName=Ra -> matches "Rashta ..." (starts-with, not contains)
        appName: filters.appName || undefined,
        appType: filters.appType || undefined,
        businessName: filters.businessName || undefined,
      });
      // ⚠️ Adjust these two lines if your API returns a different shape
      setApplications(res.data || res.apps || []);
      setTotalRows(res.total || 0);
    } catch (err) {
      console.error('Error fetching applications:', err);
      setSnackbar({ open: true, message: 'Failed to fetch applications', severity: 'error' });
    } finally {
      if (isInitial) setInitialLoading(false);
      setTableLoading(false);
    }
  };

  const handleRefresh = () => {
    fetchApplications(false);
    setSnackbar({ open: true, message: 'Applications refreshed', severity: 'success' });
  };

  const handleToggleStatus = async (app) => {
    if (!app.enabled && app.businessStatus === 'INACTIVE') {
      setSnackbar({
        open: true,
        message: 'This business is inactive — activate the business to enable its applications.',
        severity: 'warning',
      });
      return;
    }
    try {
      setActionLoading(true);
      await adminService.toggleBusinessAppStatus(app._id, !app.enabled);
      setSnackbar({ open: true, message: `Application ${app.enabled ? 'disabled' : 'enabled'}`, severity: 'success' });
      await fetchApplications(false);
    } catch (err) {
      setSnackbar({
        open: true,
        message: err?.response?.data?.message || err?.message || 'Failed to update status',
        severity: 'error',
      });
    } finally {
      setActionLoading(false);
    }
  };

  const handleRotateSecret = async (app) => {
    try {
      setActionLoading(true);
      const res = await adminService.rotateBusinessAppSecret(app._id);
      setSecretDialog({ app, secret: res.secretKey || res.secret });
      setSnackbar({ open: true, message: 'Secret rotated', severity: 'success' });
    } catch (err) {
      setSnackbar({ open: true, message: 'Failed to rotate secret', severity: 'error' });
    } finally {
      setActionLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!deleteDialog) return;
    try {
      setActionLoading(true);
      await adminService.deleteBusinessApp(deleteDialog._id);
      setSnackbar({ open: true, message: 'Application deleted', severity: 'success' });
      setDeleteDialog(null);
      await fetchApplications(false);
    } catch (err) {
      console.error('Failed to delete application:', err);
      setSnackbar({ open: true, message: 'Failed to delete application', severity: 'error' });
    } finally {
      setActionLoading(false);
    }
  };

  const handleCopy = (value) => {
    if (!value) return;
    navigator.clipboard.writeText(value).catch(() => {});
    setSnackbar({ open: true, message: 'Copied to clipboard', severity: 'success' });
  };

  const columns = [
    { field: 'appName', headerName: 'App Name', sortable: true },
    { field: 'appType', headerName: 'Type', sortable: true },
    {
      field: 'businessName',
      headerName: 'Business Name',
      sortable: true,
      render: (value) => (
        <Typography sx={{ fontSize: '0.85rem' }}>
          {value || '—'}
        </Typography>
      ),
    },
    {
      field: 'businessId',
      headerName: 'Business ID',
      width: 200,
      render: (value) => {
        const id = value || '';
        const short = id.length > 16 ? `${id.slice(0, 14)}…` : id;
        return (
          <Tooltip title={`Click to copy: ${id}`}>
            <Typography
              sx={{ fontFamily: 'monospace', fontSize: '0.75rem', cursor: 'pointer', '&:hover': { color: theme.palette.primary.main } }}
              onClick={() => handleCopy(id)}
            >
              {short}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: 'allowedDomains',
      headerName: 'Domains',
      render: (_, app) => {
        const count = Array.isArray(app.allowedDomains) ? app.allowedDomains.length : 0;
        return (
          <Chip
            label={count}
            size="small"
            sx={{
              bgcolor: isDark ? alpha(theme.palette.text.primary, 0.12) : '#f1f5f9',
              color: theme.palette.text.primary,
              fontWeight: 600,
            }}
          />
        );
      },
    },
    {
      field: 'enabled',
      headerName: 'Status',
      sortable: true,
      render: (value, app) => {
        const businessInactive = app.businessStatus === 'INACTIVE';
        const chip = (
          <Chip
            label={value ? 'ENABLED' : 'DISABLED'}
            size="small"
            onClick={() => handleToggleStatus(app)}
            sx={{
              fontWeight: 600,
              cursor: !value && businessInactive ? 'not-allowed' : 'pointer',
              bgcolor: value
                ? alpha(theme.palette.success.main, isDark ? 0.22 : 0.12)
                : alpha(theme.palette.text.primary, isDark ? 0.16 : 0.08),
              color: value
                ? theme.palette.success.main
                : theme.palette.text.secondary,
            }}
          />
        );
        return businessInactive ? (
          <Tooltip title="Business is inactive — its applications are disabled until it is activated">
            <span>{chip}</span>
          </Tooltip>
        ) : (
          chip
        );
      },
    },
    {
      field: 'actions',
      headerName: 'Actions',
      align: 'center',
      render: (_, app) => (
        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
          <Tooltip title="Edit Application">
            <span>
              <IconButton
                size="small"
                onClick={() => navigate(`/admin/applications/${app._id}/edit`)}
                sx={{ color: '#f59e0b' }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Delete Application">
            <span>
              <IconButton
                size="small"
                onClick={() => setDeleteDialog(app)}
                sx={{ color: '#ef4444' }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      ),
    },
  ];

  const hasActiveFilters = Object.values(filterInputs).some((v) => v);

  if (initialLoading) return <LoadingSpinner />;

  return (
    <Box sx={{ minHeight: '100%', background: theme.palette.background.default, p: 3 }}>
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, color: theme.palette.text.primary }}>
            Applications
          </Typography>
          <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
            Manage business applications, domains, and keys
          </Typography>
        </Box>
        <Tooltip title="Refresh Table">
          <IconButton
            onClick={handleRefresh}
            disabled={tableLoading}
            sx={{
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.text.primary,
              boxShadow: isDark ? '0 2px 8px rgba(0,0,0,0.4)' : '0 2px 8px rgba(0,0,0,0.1)',
              '&:hover': { backgroundColor: theme.palette.action.hover },
            }}
          >
            <RefreshIcon />
          </IconButton>
        </Tooltip>
      </Box>

      <Paper elevation={0} sx={{ borderRadius: 3, border: `1px solid ${theme.palette.divider}`, background: theme.palette.background.paper, boxShadow: isDark ? '0 1px 3px rgba(0, 0, 0, 0.4)' : '0 1px 3px rgba(15, 23, 42, 0.08)', p: 3 }}>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth size="small">
              <InputLabel id="app-business-filter-label">Business Name</InputLabel>
              <Select
                labelId="app-business-filter-label"
                label="Business Name"
                value={filterInputs.businessName}
                onChange={handleDropdownFilterChange('businessName')}
              >
                <MenuItem value="">All Businesses</MenuItem>
                {businesses.map((b) => (
                  <MenuItem key={b._id || b.businessId || b.businessName} value={b.businessName}>
                    {b.businessName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth size="small">
              <InputLabel id="app-type-filter-label">Type</InputLabel>
              <Select
                labelId="app-type-filter-label"
                label="Type"
                value={filterInputs.appType}
                onChange={handleDropdownFilterChange('appType')}
              >
                <MenuItem value="">All Types</MenuItem>
                <MenuItem value="web">Web Application</MenuItem>
                <MenuItem value="mobile">Mobile Application</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              size="small"
              label="App Name"
              placeholder="App Name"
              value={filterInputs.appName}
              onChange={handleFilterChange('appName')}
              InputProps={{ startAdornment: <SearchIcon fontSize="small" sx={{ mr: 1, color: '#94a3b8' }} /> }}
            />
          </Grid>
        </Grid>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 1 }}>
          {hasActiveFilters ? (
            <Button size="small" onClick={handleClearFilters} sx={{ textTransform: 'none' }}>
              Clear filters
            </Button>
          ) : <Box />}
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => navigate('/admin/applications/create')}
            sx={{ background: '#2563EB', fontWeight: 600, textTransform: 'none' }}
          >
            Add Application
          </Button>
        </Box>

        <Box sx={{ position: 'relative' }}>
          {tableLoading && (
            <Box sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: isDark ? 'rgba(17, 24, 39, 0.7)' : 'rgba(255,255,255,0.7)', zIndex: 1 }}>
              <LoadingSpinner size={40} />
            </Box>
          )}
          <DataTable
            columns={columns}
            data={applications}
            page={page}
            rowsPerPage={rowsPerPage}
            totalRows={totalRows}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
          />
        </Box>
      </Paper>

      <Dialog open={!!deleteDialog} onClose={() => !actionLoading && setDeleteDialog(null)}>
        <DialogTitle>Delete Application</DialogTitle>
        <DialogContent>
          Are you sure you want to delete <strong>{deleteDialog?.name}</strong>? This action cannot be undone.
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialog(null)} disabled={actionLoading}>Cancel</Button>
          <Button color="error" onClick={handleDelete} disabled={actionLoading}>
            {actionLoading ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={!!secretDialog} onClose={() => setSecretDialog(null)} maxWidth="sm" fullWidth>
        <DialogTitle>New Secret for {secretDialog?.app?.name}</DialogTitle>
        <DialogContent dividers>
          <Box sx={{ bgcolor: '#0f172a', color: '#e2e8f0', p: 2, borderRadius: 1, fontFamily: 'monospace', fontSize: '0.8rem' }}>
            {secretDialog?.secret}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button startIcon={<ContentCopyIcon />} onClick={() => handleCopy(secretDialog?.secret)}>Copy</Button>
          <Button onClick={() => setSecretDialog(null)}>Close</Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ApplicationList;